import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@libs/front/components/button/button.component';
import { CartePopupComponent } from '@libs/front/components/popup-panel/popup-panel.component';
import { ActivityCardField } from '../../planning.types';

@Component({
  selector: 'app-activity-card',
  standalone: true,
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss'],
  imports: [TranslateModule, ButtonComponent, CartePopupComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCardComponent {
  readonly title  = input.required<string>();
  readonly fields = input<ActivityCardField[]>([]);

  readonly seeMore = output<void>();
  readonly closed  = output<void>();
}
